<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    益田站<br>
站点介绍<br>
益田站位于深圳市福田区福强路与石厦北二街交汇处，北侧：红岭中学、益田花园，南侧：益田村、福强小学，西侧：福田花园、福强小学，东侧：中港城、益田豪园居，紧急出入口是：A出入口（福强路南侧）。车站出入口采用自然采光设计，既美观又环保，益田站以浅黄色为基调，着色稳重，按一级防火建筑标准设计和建造。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:24	00:11	3号线	2分15-20秒	4分30秒<br>
双龙	06:20	23:02	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	00:10	3号线	3分15秒	5分钟<br>
双龙	06:21	23:02	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	01:10	3号线	3分15秒	5分钟<br>
双龙	06:21	00:02	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
福强路（南）、益田路、福强小学、益田居委会、益田小学、益田豪园居、益田村、福田保税区、深圳市人才安居服务大厅<br><br>
B出入口:<br>
福强路（北）、益田路、红领中学（石厦校区）、皇岗公园，中港城<br><br>
C出入口:<br>
福强路（北）、新洲路（北）、深圳市妇幼保健院(分院)、新洲村、物业时代、益田名园、裕康时尚名居<br><br>
D出入口:<br>
福强路（南）、新洲路（南）、益田中学、益田村、福田花园大厦、金地花园、福田外国语高级中学，文化创意园、深圳市人才安居服务大厅<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 益田村<br>
M500路,M137路,339路,362路,M441路,377路,4路,26路,71路,80路,M103路,B685路,M120路,M347路,M433路,M453路<br><br>
B出入口:<br>
公交站名： 益田村<br>
B685路,M500路,M347路,M441路,M433路,M453路,4路,26路,71路,80路,M103路,M120路,M137路,339路,362路,377路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>